module.exports = __webpack_public_path__ + "img/bg_1440_0_1011.512b1c6a.png";